<template>
  <v-col class="MMVSelect" cols="12" sm="4" :style="{ display: show ? 'block  !important' : 'none  !important' }">
    <v-select
      :items="items"
      v-model="item"
      :disabled="disabled"
      :label="defaultItemText"
      solo
      @change="emitToParent"
      :placeholder="defaultItemText"
    ></v-select>
  </v-col>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'MMVSelect',
  data() {
    return {
      item: {},
      disabled: true,
      show: false
    };
  },
  props: {
    items: Array,
    type: String,
    defaultItemText: String
  },
  mounted() {
    this.disabled = this.items.length <= 0;
    this.show = this.items.length > 0;
  },
  watch: {
    items: function (val) {
      this.show = val.length > 1;
      this.item = {};
      this.disabled = this.items.length <= 0;

      if (val && val.length == 1) {
        this.item = this.items[0];
        this.show = false;
        this.emitToParent(this.item.value);
      }
      if (val && val.length == 0) {
        this.emitToParent(null);
      }
    }
  },
  methods: {
    emitToParent(selected) {
      const index = this.items.findIndex((x) => x.value == selected);
      const item = this.items.find((x) => x.value == selected);
      const data = {
        selectedIndex: index,
        item: item || {}
      };
      this.$emit('childToParent', data);
    }
  },
  computed: mapGetters(['user'])
});
</script>

<style lang="scss">
@import './src/assets/scss/_variables.scss';
.MMVSelect {
  .v-text-field__details {
    display: none;
  }
}
</style>

<i18n src="../../localization/texts.json"></i18n>
